export default "__VITE_ASSET__y9tu7oGk__"